import { api, apiGet, apiPost } from '../../../api/client';
import type { EvidenceItem, EvidenceOwnerType } from './evidenceLogic';

// Evidence files over HTTP. Uploads are multipart; a download is fetched with the caller's token and handed to the browser as a local
// blob - there is no permanent or public URL anywhere.

const unwrap = (d: any) => d?.data ?? d;

export async function uploadEvidenceFile(branchId: string, ownerType: EvidenceOwnerType, file: File): Promise<EvidenceItem> {
  const fd = new FormData();
  fd.append('branchId', branchId);
  fd.append('ownerType', ownerType);
  fd.append('file', file, file.name);
  const r = await api.post('/branch-cash/evidence', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
  return unwrap(r.data) as EvidenceItem;
}

export const listEvidenceFiles = async (ownerType: EvidenceOwnerType, ownerId: string): Promise<EvidenceItem[]> =>
  unwrap(await apiGet('/branch-cash/evidence', { ownerType, ownerId })) as EvidenceItem[];

export const removeEvidenceFile = (id: string, reason: string) => apiPost(`/branch-cash/evidence/${id}/remove`, { reason });

export async function downloadEvidenceFile(id: string, name: string): Promise<void> {
  const r = await api.get(`/branch-cash/evidence/${id}/download`, { responseType: 'blob' });
  const url = URL.createObjectURL(r.data as Blob);
  const a = document.createElement('a');
  a.href = url; a.download = name; a.rel = 'noopener';
  document.body.appendChild(a); a.click(); a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 10_000);
}
